import { Popover } from 'framework7-react';

export default Popover;